<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <section class="text-center">
    <h3>{{title}}</h3>
    <h4 v-if="subtitle" class="font-weight-bolder my-2">{{subtitle}}</h4>

    <p v-if="note">{{note}}</p>

    <section class="d-inline-flex full-width mt-2">
      <div class="ui-spacer"></div>
      <b-button class="mr-2" @click="$emit('close', true)">{{ cancelButtonText }}</b-button>
      <b-button variant="danger" @click="$emit('delete', true)">{{ deleteButtonText }}</b-button>
    </section>
  </section>
</template>
<!--eslint-enable-->

<script>
  export default {
    components: {},
    props: {
      title: {
        required: true,
        type: String,
      },
      // eslint-disable-next-line vue/require-default-prop
      subtitle: {
        required: false,
        type: String,
      },
      // eslint-disable-next-line vue/require-default-prop
      note: {
        required: false,
        type: String,
      },
      cancelButtonText: {
        type: String,
        default: 'Cancel',
      },
      deleteButtonText: {
        type: String,
        default: 'Delete',
      },
    },
    data() {
      return {
        test: '',
      };
    },
    mounted() {

    },
    methods: {

    },
  };
</script>
